/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2022
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import voucherGreen from '../../../../../../../assets/images/Fireboard/vouchers/voucherGreen.png';
import voucherRed from '../../../../../../../assets/images/Fireboard/vouchers/voucherRed.png';
import voucherWhite from '../../../../../../../assets/images/Fireboard/vouchers/voucherWhite.png';
import extraButton from "../../../../../../../assets/images/Fireboard/action.png";
import payNowPound from "../../../../../../../assets/images/Fireboard/payNowPound.png";
import FireboardUtils from '../../../../../../../util/fireboard-util';
import classes from './CheckFooter.module.css';

const CheckFooter = ({ check, managerMode, currency }) => {
  const { stationName, paid, onHandleCheckActions } = check;

  //station name fontSize
  let fontsize = '2.5vh';
  const stationLen = String(stationName).length;
  if (stationLen <= 5) {
    fontsize = '2.5vh';
  } else if (stationLen > 5 && stationLen <= 10) {
    fontsize = '1.8vh';
  } else if (stationLen > 10) {
    fontsize = '1.4vh';
  }

  return (
    <div className={classes.container}>
      <div className={classes.row}>
        <div className={classNames({ [classes.column]: true, [classes.stationCol]: true })}>
          <div style={{ fontSize: fontsize }}>{stationName}</div>
        </div>
        <div className={classNames({ [classes.column]: true, [classes.modeCol]: true })}>
          <Mode currency={currency} managerMode={managerMode} check={check} />
        </div>
        <div className={classNames({ [classes.column]: true, [classes.paidCol]: true })}>
          <img
            src={paid}
            className={classes.iconSize}
            alt="paid"
          />
        </div>
        <div
          className={classNames({ [classes.column]: true, [classes.actionCol]: true })}
          onClick={onHandleCheckActions}
        >
          <img
            src={extraButton}
            className={classes.iconSize}
            alt="action"
          />
        </div>
      </div>
    </div>
  );
};

export default CheckFooter;

CheckFooter.propTypes = {
  check: PropTypes.object,
  managerMode: PropTypes.bool,
  currency: PropTypes.string,
};

CheckFooter.defaultProps = {
  check: {},
  managerMode: false,
  currency: '$',
};

const Mode = ({ check, currency, managerMode }) => {
  const { sourceType, relatedNotifications, orders, vouchers, tab} = check || {};
  // const hasOverServerNotification = relatedNotifications && relatedNotifications.filter(n => n.notificationTypeId === 15);
  let delivery = false;
  let isMarketPlaceOrder = false;
  let imgSrc;
  if (orders && Array.isArray(orders) && orders.length > 0) {
    delivery = orders[0].delivery || false;
    isMarketPlaceOrder = orders[0].marketplace || false;
  }
  imgSrc = FireboardUtils.getCheckSourceIcon(sourceType, delivery, isMarketPlaceOrder, tab);
  if (currency === '£' && sourceType === 9) {
    imgSrc = payNowPound;
  }

  const isVoucherAvailable = (Array.isArray(vouchers) && vouchers.length > 0);
  const voucherStatus = isVoucherAvailable ? vouchers[0].status : null;
  let voucherIcon = voucherStatus === 5 ? voucherGreen : voucherStatus === 0 ? voucherWhite : voucherRed;

  return (
    <div>
      {isVoucherAvailable ? (
        <img
          src={voucherIcon}
          className={classes.voucherIconSize}
          alt="voucher"
        />
      ) : (
        managerMode ?
          // (
          //   hasOverServerNotification && hasOverServerNotification.length > 0 ? (
          //     <span>
          //       OVER SERVE
          //     </span>
          //   ) : 
          null
          // ) 
          : (
            <img
              src={imgSrc}
              className={(isMarketPlaceOrder && !delivery) ? classes.marketOrder : classes.iconSize}
              alt="mode"
            />
          )
      )}
    </div>
  );
}
